/**
 * ============================================================================
 * CustomerStats - KPI Cards Component
 * ============================================================================
 */

import React from 'react';
import { Users, UserPlus, TrendingUp, Activity } from 'lucide-react';
import type { CustomerMetrics } from '../../types/customerInsights';
import { formatRetentionRate } from '../../utils/customerInsightsFormatters';

interface CustomerStatsProps extends CustomerMetrics {}

export function CustomerStats({
  total_customers,
  new_customers,
  returning_customers,
  avg_bookings,
  return_rate,
}: CustomerStatsProps) {
  const stats = [
    {
      label: 'Total Customers',
      value: total_customers.toString(),
      subtext: 'All-time customers',
      icon: Users,
      colorClass: 'bg-blue-50 text-blue-600',
    },
    {
      label: 'New Customers',
      value: new_customers.toString(),
      subtext: 'This period',
      icon: UserPlus,
      colorClass: 'bg-green-50 text-green-600',
    },
    {
      label: 'Retention Rate',
      value: formatRetentionRate(return_rate),
      subtext: 'Returning customers',
      icon: TrendingUp,
      colorClass: 'bg-purple-50 text-purple-600',
    },
    {
      label: 'Avg Bookings',
      value: avg_bookings.toFixed(1),
      subtext: 'Per customer',
      icon: Activity,
      colorClass: 'bg-orange-50 text-orange-600',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {stats.map((stat, idx) => (
        <div key={idx} className="bg-white rounded-xl p-3 border border-gray-200">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-gray-600 text-xs mb-1 truncate">{stat.label}</p>
              <p className="text-lg sm:text-xl font-black text-gray-900 truncate">{stat.value}</p>
            </div>
            <div
              className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg ${stat.colorClass} flex items-center justify-center flex-shrink-0 ml-2`}
            >
              <stat.icon className="w-4 h-4 sm:w-5 sm:h-5" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
